import Login from '../../pages/Auth/Login';
import withLogged from '../../shared/hocs/withLogged';

const routersOther = [{ path: '/', element: withLogged(Login) }];
export default routersOther;
